import React, { useEffect } from "react";
import { useApiIsLoaded, useMap } from '@vis.gl/react-google-maps';
import IBuildrProps from "../../utilities/IBuildrProps";

export interface IMapMarkersProps extends IBuildrProps {
    children: any,
    panTo: { lat: number, lng: number } | null,
}

export default ({ children, panTo }: IMapMarkersProps) => {
    const macuComMap = useMap();
    const mapsApiLoaded = useApiIsLoaded();

    const loadChildren = () => {
        if (window.google && macuComMap) {
            const bounds = new window.google.maps.LatLngBounds();

            children.map((child) => {
                const { latitude, longitude } = child.props;

                if (latitude !== undefined && longitude !== undefined) {
                    const latLng = new window.google.maps.LatLng(Number(latitude), Number(longitude));
                    if (children.length > 1) {
                        bounds.extend(latLng);
                    } else {
                        macuComMap.setCenter(latLng);
                        macuComMap.setZoom(14);
                    }
                }
            });

            if (children.length > 1) {
                macuComMap.fitBounds(bounds);
            }
        }
    };

    useEffect(() => {
        if (panTo) {
            macuComMap.panTo(panTo);
        }
    }, [panTo]);

    useEffect(() => {
        if (children && children.length && mapsApiLoaded && macuComMap && !panTo) {
            loadChildren();
        }
    }, [children, mapsApiLoaded]);

    return (
        <>
            {children}
        </>
    );
};